module.exports = __webpack_public_path__ + "static/media/top-img_7a.0a62cf41.png";